import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function t(field, lang = 'en') {
  if (!field) return '';
  return field[lang] || field.en || '';
}

export default function PrivacyPolicy() {
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const savedLang = localStorage.getItem('ets_lang');
    if (savedLang) setLang(savedLang);
  }, []);

  const content = {
    back: { en: '← Back to Home', zh: '← 返回首頁' },
    title: { en: 'Privacy Policy', zh: '隱私權政策' },
    lastUpdated: { en: 'Last updated: ', zh: '最後更新：' },
    
    sec1Title: { en: '1. Introduction', zh: '1. 簡介' },
    sec1P1: { en: 'Welcome to Every Talent Shines Academy (ETS). We respect your privacy and are committed to protecting your personal data.', zh: '歡迎來到 Every Talent Shines Academy (ETS)。我們尊重您的隱私並致力於保護您的個人資料。' },
    
    sec2Title: { en: '2. Personal Data Collection (Mandatory Purposes)', zh: '2. 個人資料收集（強制性用途）' },
    sec2P1: { en: 'The name, date of birth, emergency contact details and other personal data collected by our school will be used for enrolment procedures, class allocation, student record keeping and internal administrative purposes.', zh: '本校收集的姓名、出生日期、緊急聯絡資料及其他個人資料將用於入學手續、分班、學生紀錄保存及內部行政用途。' },
    sec2P2: { en: 'When students participate in external performances or competitions, our school will provide the necessary information (such as name and age) to the event organiser for identity verification only. Parent/guardian contact details will not be provided.', zh: '當學生參加對外表演或比賽時，本校將向活動主辦單位提供必要資料（如姓名及年齡）僅供身分核實。家長/監護人的聯絡資料將不會提供。' },
    
    sec3Title: { en: '3. Image and Media Use (Promotional and Publicity Purposes)', zh: '3. 圖像及媒體使用（推廣及宣傳用途）' },
    sec3P1: { en: 'On a voluntary basis (which does not affect enrolment or performance opportunities), photos or videos of students taken by instructors during classes, rehearsals or performances may be used on our school\'s official platforms, including Facebook, Instagram, YouTube and Xiaohongshu (RED).', zh: '在自願基礎上（這不會影響入學或表演機會），導師在課堂、排練或表演期間拍攝的學生照片或影片可能會用於本校的官方平台，包括 Facebook、Instagram、YouTube 及小紅書（RED）。' },
    sec3P2: { en: 'Photos of students may also be used on our school\'s official website, promotional leaflets, posters or yearbooks. Instructors may share photos/videos of class activities featuring students in our school\'s official WhatsApp parent group.', zh: '學生照片也可能用於本校的官方網站、宣傳單張、海報或年刊。導師可能會在本校的官方 WhatsApp 家長群組分享包含學生的課堂活動照片/影片。' },
    
    sec4Title: { en: '4. Data Security', zh: '4. 資料安全' },
    sec4P1: { en: 'We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way, altered, or disclosed.', zh: '我們已實施適當的安全措施，以防止您的個人資料意外遺失、被未經授權使用或存取、更改或披露。' },
    
    sec5Title: { en: '5. Contact Us', zh: '5. 聯絡我們' },
    sec5P1: { en: 'If you have any questions about this privacy policy or our privacy practices, please contact us at info@etsacademy.com.', zh: '如果您對本隱私權政策或我們的隱私保護措施有任何疑問，請透過 info@etsacademy.com 聯絡我們。' }
  };

  return (
    <div style={{ backgroundColor: '#111111', minHeight: '100vh', color: '#f5f5f5', padding: '40px 20px', fontFamily: "'Outfit', sans-serif" }}>
      <div style={{ maxWidth: 800, margin: '0 auto', backgroundColor: '#1a1a1a', padding: 40, borderRadius: 16, border: '1px solid rgba(255,255,255,0.1)' }}>
        <Link to="/" style={{ color: '#c04060', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 8, fontWeight: 600, marginBottom: 32 }}>
          {t(content.back, lang)}
        </Link>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h1 style={{ fontSize: 32, fontWeight: 700, color: '#fff', fontFamily: "'Playfair Display', serif", margin: 0 }}>{t(content.title, lang)}</h1>
          
          <div style={{ display: 'flex', backgroundColor: '#333', borderRadius: 20, padding: 4 }}>
            <button 
              onClick={() => { setLang('en'); localStorage.setItem('ets_lang', 'en'); }}
              style={{ background: lang === 'en' ? '#c04060' : 'transparent', color: '#fff', border: 'none', borderRadius: 16, padding: '4px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
            >EN</button>
            <button 
              onClick={() => { setLang('zh'); localStorage.setItem('ets_lang', 'zh'); }}
              style={{ background: lang === 'zh' ? '#c04060' : 'transparent', color: '#fff', border: 'none', borderRadius: 16, padding: '4px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
            >繁中</button>
          </div>
        </div>
        
        <div style={{ lineHeight: 1.6, fontSize: 15, color: 'rgba(255,255,255,0.8)' }}>
          <p style={{ marginBottom: 16 }}>{t(content.lastUpdated, lang)}{new Date().toLocaleDateString()}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec1Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec1P1, lang)}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec2Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec2P1, lang)}</p>
          <p style={{ marginBottom: 16 }}>{t(content.sec2P2, lang)}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec3Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec3P1, lang)}</p>
          <p style={{ marginBottom: 16 }}>{t(content.sec3P2, lang)}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec4Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec4P1, lang)}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec5Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec5P1, lang)}</p>
          <div style={{ marginTop: 24, padding: 16, backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: 8, lineHeight: 1.6 }}>
            <strong style={{ color: '#fff' }}>ETS (a.k.a Every Talent Shine Academy)</strong><br />
            UNIT20A, 5/F SING WIN FACTORY BUILDING<br />
            15-17 SHING YIP STREET KWUN TING,<br />
            KOWLOON HONG KONG<br />
            Represented By: Mrs. Esther Lam
          </div>
        </div>
      </div>
    </div>
  );
}
